import React, { useState, useEffect } from 'react';
import AbaDadosPaciente from './AbaDadosPaciente';
import AbaAnamnese from './AbaAnamnese';
import EncaminhamentosPaciente from '../EncaminhamentosPaciente';
import PaginaTratamento from '../../pages/PaginaTratamento';

export default function FormPaciente({ onNovoPaciente, pacienteEditando, onFimEdicao, onDirtyChange }) {
  const [abaAtiva, setAbaAtiva] = useState('dados');

  // Reseta para a aba de dados sempre que o paciente selecionado mudar
  useEffect(() => {
    setAbaAtiva('dados');
  }, [pacienteEditando]);

  // Construção dinâmica das abas (só mostra as extras se estiver editando)
  const abas = [
    { id: 'dados', label: 'Dados do Paciente' },
    ...(pacienteEditando ? [
      { id: 'anamnese', label: 'Anamnese' },
      { id: 'encaminhamentos', label: 'Encaminhamentos' },
      { id: 'tratamento', label: 'Tratamento' }
    ] : [])
  ];

  return (
    <div className="bg-white mx-auto w-full rounded-2xl p-6 h-full shadow-sm flex flex-col" style={{ scrollbarGutter: 'stable both-edges' }}>
      
      {/* Navegação das Abas Modernizada */}
      <div className="flex border-b mb-6 gap-6 overflow-x-auto">
        {abas.map(aba => (
          <button
            key={aba.id}
            onClick={() => setAbaAtiva(aba.id)}
            className={`relative pb-2 text-sm md:text-base whitespace-nowrap transition-colors after:content-[''] after:absolute after:left-0 after:-bottom-[1px] after:h-[2px] after:rounded after:transition-all after:duration-300 after:ease-out after:w-0 focus:outline-none
              ${abaAtiva === aba.id ? 'text-[#0095DA] font-medium after:w-full after:bg-[#0095DA]' : 'text-gray-500 hover:text-gray-800 hover:after:w-full hover:after:bg-gray-300'}`}
          >
            {aba.label}
          </button>
        ))}
      </div>

      {/* Renderização Condicional (O Roteador Interno) */}
      <div className="flex-1 animate-fade-in relative">
        {abaAtiva === 'dados' && (
          <AbaDadosPaciente
            onNovoPaciente={onNovoPaciente}
            pacienteEditando={pacienteEditando}
            onFimEdicao={onFimEdicao}
            onDirtyChange={onDirtyChange}
          />
        )}

        {abaAtiva === 'anamnese' && pacienteEditando && (
          <AbaAnamnese pacienteEditando={pacienteEditando} />
        )}

        {abaAtiva === 'encaminhamentos' && pacienteEditando && (
          <EncaminhamentosPaciente pacienteId={pacienteEditando.id} />
        )}

        {abaAtiva === 'tratamento' && pacienteEditando && (
          <PaginaTratamento pacienteSelecionado={pacienteEditando} />
        )}
      </div>
      
    </div>
  );
}